import React, { useEffect } from "react";
import ErrorCard from "../../components/Cards/Error";
import { Container } from "./NotFoundStyled";
import { useTranslate } from "hooks/translation-hooks";
import { addGtmPageView as pageview } from "redux/actions/gtmActions";
import { useDispatch } from "react-redux";

export const NotFound = () => {
  const t = useTranslate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageview("/not-found"));
  }, [dispatch]);
  return (
    <Container>
      <ErrorCard t={t} />
    </Container>
  );
};

export default NotFound;
